import React from 'react';
import Layout from '../components/Layout';
import { useTranslation } from 'react-i18next';
import './Marketing.css';

const Marketing = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <div className="marketing-page">
        <div className="marketing-content">
          <h1 className="marketing-title">{t('marketing.title', 'Marketing')}</h1>
          <p className="marketing-description">
            {t('marketing.in_development', 'Página de Marketing em desenvolvimento.')}
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Marketing;

